export default __webpack_public_path__ + "static/media/adminlogin.35fe9ed2.png";